export enum END_POINT {
  GET_PROJECT_TRANSACTIONS_SUMMARY = "user/getProjectTransactionsSummary",
  GET_TRANSACTIONS_BY_PROJECT = "user/getAllTransactionsByProject",
  GET_WORKTASKS_BY_PROJECT = "user/getAllPackages",
  GET_FEEDBACKS = "user/getAllFeedBacksOfACandidate",
  GET_FEEDBACK_DETAIL = "user/getFeedBackDetail",
}
